import { render, staticRenderFns } from "./Municipii.vue?vue&type=template&id=1795a191"
import script from "./Municipii.vue?vue&type=script&lang=js"
export * from "./Municipii.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports